// @flow
import * as React from 'react';

export function usePrintMode() {
  const [inPrintMode, setPrintMode] = React.useState(
    // matchMedia may not be present in SSR runtimes
    () => window?.matchMedia?.('print').matches ?? false,
  );
  React.useEffect(() => {
    const mediaQueryList = window.matchMedia('print');
    function onMediaQueryChange(event) {
      console.log('change', event.matches);
      setPrintMode(event.matches);
    }
    mediaQueryList.addEventListener('change', onMediaQueryChange);
    return () => {
      mediaQueryList.removeEventListener('change', onMediaQueryChange);
    };
  }, []);
  return inPrintMode;
}
